import { render } from "./ConfigureAccount.vue?vue&type=template&id=2a51a9e1"
import script from "./ConfigureAccount.vue?vue&type=script&lang=js"
export * from "./ConfigureAccount.vue?vue&type=script&lang=js"

import "./ConfigureAccount.vue?vue&type=style&index=0&id=2a51a9e1&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__